import { Component, Inject, OnInit } from '@angular/core';
import { LoadingBarService } from '@ngx-loading-bar/core';
import { DOCUMENT } from '@angular/common';
import { Subject } from 'rxjs';
import { AnimationOptions } from 'ngx-lottie';
import { LoadLottieService } from './_services/load-lottie.service';
import { LanguageService } from './_services/language.service';
import { environment } from 'src/environments/environment';
import { DeviceDetectorService } from './_services/device-detector.service';
import { NavigationCancel, NavigationEnd, Router } from '@angular/router';
import { AppConstants } from './_helpers/app.constants';

@Component({
  selector: 'app-main',
  templateUrl: 'app.component.html',
  styleUrls: ['./app.component.css']
})

export class AppComponent implements OnInit {
  loading: boolean = false;
  options: AnimationOptions = {
    path: 'assets/animation/63487-programming-computer.json',
    autoplay: true,
    loop: true
  };
  public isLoading$ = this.loadingService.spinnerVisible$;
  public _menuSettingsConfig: any;
  public _themeSettingsConfig: any;
  public _unsubscribeAll: Subject<any>;
  private _unsubscribeAllMenu: Subject<any>;
  public showContent = false;
  public title;
  constructor(
    @Inject(DOCUMENT) private document: Document,
    public loader: LoadingBarService,
    private loadingService : LoadLottieService,
    private languageService : LanguageService,
    private router : Router,
    private deviceService : DeviceDetectorService
    // private _menuSettingsService : MenuEgresadoSettingsService,
    // private _themeSettingsService : ThemeSettingsEgresadoService
  ) {
    this._unsubscribeAll = new Subject();
    this._unsubscribeAllMenu = new Subject();
    // this.setTitle();
  }
  
  ngOnInit() {
    this.languageService.init(environment.defaultLanguage, environment.supportedLanguages, true);
    // this._menuSettingsService.config
    //   .pipe(takeUntil(this._unsubscribeAllMenu))
    //   .subscribe((config) => {
    //     this._menuSettingsConfig = config;
    //   });
    // this._themeSettingsService.config
    //   .pipe(takeUntil(this._unsubscribeAll))
    //   .subscribe((config) => {
    //     this._themeSettingsConfig = config;
    //   });
    // page progress bar percentage
    this.showContent = true;//comenté lo de abajo
    this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd || event instanceof NavigationCancel) {
        // set page progress bar loading to end on NavigationEnd event router
        // this.loader.complete();
        this.showContent = true;
        // close menu for mobile view
        if (this.deviceService.isMobile() || window.innerWidth < AppConstants.MOBILE_RESPONSIVE_WIDTH) {
          if (document.body.classList.contains('menu-open')) {
            document.body.classList.remove('menu-open');
            document.body.classList.add('menu-close');
          }
        }
      }
    });
  }

  setTitle() {
    this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        if (this._themeSettingsConfig.layout.style === 'vertical') {
          for (let i = 0; i < this._menuSettingsConfig?.vertical_menu.items.length; i++) {
            if (!this._menuSettingsConfig?.vertical_menu.items[i].submenu &&
              this._menuSettingsConfig.vertical_menu?.items[i].page === this.router.url) {
              this.title = this._menuSettingsConfig.vertical_menu?.items[i].title;
              break;
            } else if (this._menuSettingsConfig.vertical_menu?.items[i].submenu) {
              // Level 1 menu
              for (let j = 0; j < this._menuSettingsConfig.vertical_menu?.items[i].submenu.items.length; j++) {
                if (!this._menuSettingsConfig.vertical_menu?.items[i].submenu.items[j].submenu &&
                  this._menuSettingsConfig.vertical_menu.items[i].submenu.items[j].page === this.router.url) {
                  this.title = this._menuSettingsConfig.vertical_menu.items[i].submenu.items[j].title;
                  break;
                } else if (this._menuSettingsConfig.vertical_menu.items[i].submenu.items[j].submenu) {
                  // Level 2 menu
                  for (let k = 0; k < this._menuSettingsConfig.vertical_menu.items[i].submenu.items[j].submenu.items.length; k++) {
                    if (this._menuSettingsConfig.vertical_menu.items[i].submenu.items[j].submenu.items[k].page === this.router.url) {
                      this.title = this._menuSettingsConfig.vertical_menu.items[i].submenu.items[j].submenu.items[k].title;
                    }
                  }
                }
              }
            }
          }
        } else if (this._themeSettingsConfig.layout.style === 'horizontal') {
          for (let i = 0; i < this._menuSettingsConfig.horizontal_menu.items.length; i++) {
            if (!this._menuSettingsConfig.horizontal_menu.items[i].submenu &&
              this._menuSettingsConfig.horizontal_menu.items[i].page === this.router.url) {
              this.title = this._menuSettingsConfig.horizontal_menu.items[i].title;
              break;
            } else if (this._menuSettingsConfig.horizontal_menu.items[i].submenu) {
              // Level 1 menu
              for (let j = 0; j < this._menuSettingsConfig.horizontal_menu.items[i].submenu.items.length; j++) {
                if (!this._menuSettingsConfig.horizontal_menu.items[i].submenu.items[j].submenu &&
                  this._menuSettingsConfig.horizontal_menu.items[i].submenu.items[j].page === this.router.url) {
                  this.title = this._menuSettingsConfig.horizontal_menu.items[i].submenu.items[j].title;
                  break;
                } else if (this._menuSettingsConfig.horizontal_menu.items[i].submenu.items[j].submenu) {
                  // Level 2 menu
                  for (let k = 0; k < this._menuSettingsConfig.horizontal_menu.items[i].submenu.items[j].submenu.items.length; k++) {
                    if (this._menuSettingsConfig.horizontal_menu.items[i].submenu.items[j].submenu.items[k].page === this.router.url) {
                      this.title = this._menuSettingsConfig.horizontal_menu.items[i].submenu.items[j].submenu.items[k].title;
                    }
                  }
                }
              }
            }
          }
        }
      }
    });
  }
}
